import React 		from 'react';
import ReactDOM 	from 'react-dom';

import BLComponent	from '../core/_BLComponent.jsx';
import AnniversaryLogo from '../common/_AnniversaryLogo.jsx';
import NewsCard from '../common/_NewsCard.jsx';
import HiddenScroll from '../common/_HiddenScroll.jsx';

import AnniversaryStories from './_AnniversaryStories.jsx';

export default class About extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			storeName: blapp.session.getMe() && blapp.session.getMe().store ? blapp.session.getMe().store.skUsernameOwner : '%STORE_NAME%',
			copied: ''
		};

		this.news = blapp.models.get('news') || [];
	}

	render() {
		return (
			<main className="main main--white about-page">
				<div className="main__content">
					{this.renderIntro()}
					{this.renderOrigins()}
					{this.renderWorks()}
					{this.renderStudio()}
					{this.render20Years()}
					{/* {this.renderNews()} */}
					{this.renderExtra()}
				</div>
			</main>
		);
	}

	renderIntro() {
		return (
			<section className="edge-to-edge-container about-page__intro">
				<div className="edge-to-edge-container__internal about-page__intro-internal">
					<div className="about-page__intro-section">
						<h1 className="text--xxl-title text--tight l-margin-bottom--xl">About the team</h1>
						<p className="l-margin-bottom">The team here at BrickLink is a small, diverse, and dedicated group of LEGO&reg; fans. With a team that consists of less than 30 people, it’s no surprise that much like LEGO bricks, we have multiple roles that contribute to our vision. When we need a quick break, you can find us having a meal or coffee together in the kitchen. Or you can find us building the latest LEGO sets on “build nights” where we regroup and enjoy downtime.</p>
						<p>Whatever the activity may be, we always strive to elevate team spirit and remain connected by learning from the BrickLink community and from each other.</p>
					</div>
					<div className="about-page__intro-section">
						<h2 className="text--xxl-title text--tight l-margin-bottom--xl">Our vision</h2>
						<p>We want to be true to the LEGO Group’s original idea of a universal building system and encourage more people to enjoy free building beyond childhood. We believe that the joy of building can be amplified through interacting with likeminded LEGO fans like yourself who appreciate imagination and creativity with offset in the LEGO bricks.​ To further empower your creativity, we seek to resolve the pain points that prevent you from finding the LEGO bricks you need and expressing whatever idea you might have and want to realize.</p>
					</div>
				</div>
			</section>
		);
	}

	render20Years() {
		return (
			<section className="edge-to-edge-container about-page__celebrating-container">
				<div className="edge-to-edge-container__internal about-page__celebrating">
					<div className="about-page__celebrating-intro">
						<AnniversaryLogo classes="about-page__celebrating-logo" whiteBg />
						<h1 className="about-page__celebrating-title">20 Years of BrickLink Stories</h1>
						<p>Read our members' stories about their BrickLink moments - how it all started, what made a difference, where things are today, and what's next.</p>
						<a className="about-page__celebrating-cta" href={blapp.url2.getAnniversaryStoriesUrl()}>See all stories</a>
					</div>
					<div className="about-page__celebrating-stories">
						<AnniversaryStories/>
					</div>
				</div>
			</section>
		);
	}

	renderOrigins() {
		return (
			<section className="edge-to-edge-container about-page__origins">
				<div className="edge-to-edge-container__internal">
					<div className="about-page__content-split about-page__content-split--origins">
						<div className="about-page__content-split-col">
							<h2 className="about-page__section-title">How it started and where we are going</h2>
							<p className="l-margin-bottom"><a href="https://www.danjezek.com/" target="_blank">Dan Jezek</a>, a computer programmer and an Adult Fan of LEGO (AFOL), has always been passionate about LEGO products. He showed interest and real care for the LEGO community at a very young age. With his parents’ support and encouragement, Dan pursued his dream of creating a place where LEGO bricks were easy to find and available at hand.  </p>
							<p>On June 19, 2000, BrickLink (or as it was called back then, BrickBay) was born. What started as an idea and as a “maybe” turned into one of the best platforms for buying and selling LEGO bricks and sets ever created. BrickLink became a place where LEGO fans would connect with each other and share the same drive and enthusiasm. From simply being curious to becoming a seller, a collector, or buyer, BrickLink grew to be the place for them to find anything from sold-out sets to retired pieces. </p>
						</div>
						<div className="about-page__content-split-col about-page__content-split-col--image">
							<figure className="about-page__fig about-page__fig--diorama">
								<img className="about-page__fig-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/about/diorama.png"}/>
								<figcaption className="about-page__fig-caption">Eliska’s “Inside” MOC displays vignettes of images on interior pages of the website.</figcaption>
							</figure>
						</div>
					</div>
					<div className="about-page__content-split about-page__content-split--origins">
						<div className="about-page__content-split-col about-page__content-split-col--image">
							<figure className="about-page__fig about-page__fig--castle">
								<img className="about-page__fig-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/about/lowenstein.png"}/>
								<figcaption className="about-page__fig-caption">Löwenstein Castle designed by Raziel_Regulus<br/>Official set from the AFOL Designer Program</figcaption>
							</figure>
						</div>
						<div className="about-page__content-split-col">
							<p className="l-margin-bottom">Dan created a profound example of helping the AFOL community grow and connect individual LEGO fans via the Internet, and he operated BrickLink for over a decade until he passed away in 2010. The torch was passed on to Jay Kim, a fellow AFOL, who took over BrickLink operations and began the improvement work that laid the foundation for the BrickLink you know today. Jay also invested in developing Studio, a digital building software. The work the BrickLink team spearheaded, and will continue to push forward with, has been a huge gain for the growing group of builders who see benefits of building with LEGO bricks using an advanced yet user-friendly software. </p>
							<p className="l-margin-bottom">In 2018, we identified an opportunity to collaborate with the LEGO Group on the <a href={blapp.url2.getCrowdProjectPastADPUrl()} target="_blank">AFOL Designer Program (ADP)</a>. This program ran for about one year and helped realize unique fan designs with truly original themes and rich backstories. We learned that there is so much more we can do to empower and support LEGO creativity, whether it’s through providing tools for creative self-expression or making fan designs available to a wider audience. By late 2019, we officially become a part of the LEGO Group. Whether you are a BrickLink seller, buyer, builder, or just like to hang around, your BrickLink team remains dedicated to continuing the journey of being your preferred and valuable partner!</p>
							<a href="https://www.danjezek.com/bricklink.html" target="_blank" className="l-block">Learn more about BrickLink's history</a>
							{/* <p>To learn more about the future of BrickLink under the LEGO Group’s ownership or read official announcements, visit the <a href={blapp.url2.getLEGOFAQUrl()} target="_blank">FAQ page</a>.</p> */}
						</div>
					</div>
				</div>
			</section>
		);
	}

	renderWorks() {
		return (
			<section className="about-page__content-section">
				<div className="about-page__content-split">
					<div className="about-page__content-split-col">
						<h2 className="about-page__section-title">How BrickLink works</h2>
						<p className="l-margin-bottom--xl">BrickLink is the leading marketplace for genuine LEGO products and contains an <a href="https://www.bricklink.com/catalog.asp" target="_blank">extensive catalog</a> of every LEGO element and set you can think of. With an account, you can buy and sell LEGO elements and sets locally and internationally. You can also create <a href={blapp.url2.getWantedListUrl()} target="_blank">Wanted Lists</a> to keep track of ongoing projects, inventory, etc.</p>
						{!blapp.session.isLoggedIn() && <a href={`${blapp.url2.getUrlInfoBase('/register/main.page').path}?returnTo=${window.location.href}`} className="btn text-color--black l-inline-block">Create an account</a>}

						<div className="about-page__stats">
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-store fa-fw l-margin-right"/>
									10k+
								</div>
								<p>Sellers in the marketplace</p>
							</div>
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-globe fa-fw l-margin-right"/>
									70
								</div>
								<p>Countries</p>
							</div>
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-users fa-fw l-margin-right"/>
									1m+
								</div>
								<p>Registered members</p>
							</div>
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-cubes fa-fw l-margin-right"/>
									127k+
								</div>
								<p>Unique items</p>
							</div>
						</div>
					</div>
					<div className="about-page__content-split-col about-page__content-split-col--hide">
						<figure className="about-page__fig about-page__fig--stylized">
							<img className="about-page__fig-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/about/how-bl-works.png"} alt="BrickLink website on two mobile devices"/>
						</figure>
					</div>
				</div>
			</section>
		);
	}

	renderStudio() {
		return (
			<section className="about-page__content-section l-border-bottom--null">
				<div className="about-page__content-split">
					<div className="about-page__content-split-col about-page__content-split-col--hide">
						<figure className="about-page__fig about-page__fig--stylized">
							<img className="about-page__fig-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/about/studio-screenshot.png"} alt="Studio workspace on a laptop"/>
						</figure>
					</div>
					<div className="about-page__content-split-col">
						<h2 className="about-page__section-title">Studio 2.0</h2>
						<p className="l-margin-bottom">The BrickLink team started building <a href={blapp.url2.getStudioDownloadUrl()} target="_blank">Studio</a> in 2014 with the goal of providing a robust digital building software where designers can not only build, but also render and create instructions. These all-in-one features allowed the software to be exclusively used for submitting designs to the AFOL Designer Program.</p>
						<p className="l-margin-bottom--xl">If you enjoy making your own creations, you can post them to the <a href={blapp.url2.getStudioGalleryUrl()} target="_blank">Studio Gallery</a> where everyone can view and leave comments on your creation.</p>
						<a href={blapp.url2.getStudioGalleryUrl()} target="_blank" className="btn l-inline-block text-color--black">Explore Studio Gallery</a>

						<div className="about-page__stats">
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-download fa-fw l-margin-right"/>
									525k+
								</div>
								<p>Downloads</p>
							</div>
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon fas fa-power-off fa-fw l-margin-right"/>
									8m+
								</div>
								<p>Executions</p>
							</div>
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-file-image fa-fw l-margin-right"/>
									2m+
								</div>
								<p>Images rendered</p>
							</div>
							<div className="about-page__stats-item">
								<div className="about-page__stats-item-header">
									<i className="about-page__stats-item-icon far fa-cubes fa-fw l-margin-right"/>
									7,729
								</div>
								<p>Parts in studio</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}

	renderNews() {
		const news = this.news.map( (n) => <NewsCard classes="about-page__news-card" data={{date: n.dtDate, title: n.strTitle, intro: n.strSubtitle, link: blapp.url2.getNewsPage(n.idMessage), replies: n.nRepliesCnt}}/>)
		return (
			<section className="about-page__content-section about-page__content-section--padded-mob">
				<div className="l-flex l-split l-baseline l-margin-bottom--sm">
					<h2 className="about-page__section-title">News from BrickLink</h2>
					<a href="https://www.bricklink.com/messageList.asp?ID=78" target="_blank" className="l-hide--small">See all articles</a>
				</div>
				<div className="card-container about-page__news-content">
					<HiddenScroll>
						{news}
					</HiddenScroll>
				</div>
				<a href="" className="l-hide--desktop l-margin-top--xl l-inline-block">See all articles</a>
			</section>
		);
	}

	renderExtra() {
		return (
			<section className="about-page__content-section">
				<div className="about-page__content-split about-page__content-split--extra">
					<div className="about-page__content-split-col">
						<h2 className="about-page__section-title">BrickLink Community Expert Program</h2>
						<p className="l-margin-bottom">To maintain accurate and up-to-date product details, the BrickLink Catalog is supported by Catalog Associates and Inventories Administrators. The BrickLink community is supported by Discussions Moderators, Collage Moderators, Links Administrators, and Translated Help Editors.</p>
						<a href="https://www.bricklink.com/memberAdmins.asp" target="_blank">View Community Experts</a>
					</div>
					<div className="about-page__content-split-col">
						<h2 className="about-page__section-title">Brand assets</h2>
						<p className="l-margin-bottom">If you would like to use BrickLink logos, please refer to our brand guidelines. Here, you can download different versions of the logo and view a general guideline of best practices.</p>
						<a href={blapp.url2.getBrandUrl()} target="_blank">View guidelines</a>
					</div>
				</div>
			</section>
		);
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<About blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);